const BREAKPOINTS = {
  XS: 0,
  SM: 576,
  MD: 768,
  LG: 992,
  XL: 1415,
} as const;

export type Breakpoint = (typeof BREAKPOINTS)[keyof typeof BREAKPOINTS];

export default BREAKPOINTS;
